<template>
  <div style="background: linear-gradient(to bottom, #f0f8ff, #e6f7ff);">
    <Header/>
    <div id="checkoutOrder">

      <!-- 订单容器 -->
      <div class="order-container">

        <!-- 地址选择区域 -->
        <div class="address-section">
          <h3 class="section-title">
            <i><i><img src="@/assets/icon/weizhi.png" style="width: 17px;margin-bottom: 4px;" /></i></i>
            <span>收货地址</span>
          </h3>

          <div v-if="!selAddress" style="text-align: center;">
            <p style="font-weight: 550">暂无收货地址，请前往个人中心，新增收货地址！</p>
            <a-button type="primary" @click="() => {
            this.$router.push({
            path: '/account',
            query: {
              key: 'address'
            }
            })
          }">前往管理</a-button>
            <a-divider/>
          </div>
          <template v-else>
            <div class="address-card active">
              <div class="address-icon">
                <i class="fas fa-home"></i>
              </div>
              <div class="address-info">
                <div class="address-header">
                  <div>
                    <span class="address-name">{{ `${receiverStr}` }}</span>
                  </div>
                  <div class="address-phone" @click="visible = true, addressData = selAddress">编辑</div>
                </div>
                <div class="address-detail">
                  {{ `${addressStr}` }}
                </div>
              </div>
            </div>

            <div class="addr-expand" :class="{expanded: addressExpanded}" @click="addressExpanded = !addressExpanded">
              <span>更多地址</span>
              <b></b>
            </div>

            <div v-show="addressExpanded">
              <div class="address-card" v-for="addr in addressList" :key="addr.id" @click="handleSelectAddress(addr)">
                <div class="address-icon">
                  <i class="fas fa-home"></i>
                </div>
                <div class="address-info">
                  <div class="address-header">
                    <div>
                      <span class="address-name">{{ `${addr.name} ${addr.phoneNumber}` }}</span>
                    </div>
                    <div class="address-phone" @click.stop="visible = true, addressData = addr">编辑</div>
                  </div>
                  <div class="address-detail">
                    {{ `${addr.parentCodeName} ${addr.codeName}` }} {{ `${addr.detailedAddress}` }}
                  </div>
                </div>
              </div>
            </div>
          </template>
<!--          <div class="add-address-btn">-->
<!--            <i class="fas fa-plus"></i>-->
<!--            <span>添加新地址</span>-->
<!--          </div>-->
        </div>

        <!-- 商品信息区域 -->
        <div class="products-section" v-for="item in goodsList" :key="item.companyId">
          <h3 class="section-title">
            <i><img src="@/assets/icon/xiangzi.png" style="width: 20px;margin-bottom: 4px;" /></i>
            <span>商品信息</span>
          </h3>

          <div class="company-header">
<!--            <div class="company-logo">A</div>-->
            <div class="company-name">{{ item.companyName }}</div>
          </div>

          <div class="product-list">
            <div class="product-item" v-for="goods in item.shoppingCarts" :key="goods.id">
              <div class="product-image">
               <img :src="getFileUrl(goods.bridgePicUrl) || '/noimage.png'" style="width: 100%" />
              </div>
              <div class="product-info">
                <div class="product-name">{{ goods.name }}</div>
                <div class="product-quantity">x{{ goods.count }}</div>
              </div>
              <div class="product-price">
                <div class="points-value"><i><img src="@/assets/icon/jifen2.png" style="width: 17px;margin-bottom: 4px;" /></i> {{ goods.points }}</div>
                <div class="subtotal">小计: {{ (goods.points * goods.count).toFixed(2) }}积分</div>
              </div>
            </div>
          </div>
          <!-- 备注区域 -->
          <div class="remark-section">
            <h3 class="section-title">
              <i><img src="@/assets/icon/beizhu.png" style="width: 17px;margin-bottom: 4px;" /></i>
              <span>订单备注</span>
            </h3>
            <textarea class="remark-input" v-model="item.remark" placeholder="请输入订单备注信息（选填）"></textarea>
          </div>
        </div>

        <!-- 支付信息区域 -->
        <div class="payment-section">
          <div class="payment-summary">
            <div class="summary-row">
              <div class="summary-label">商品总积分</div>
              <div class="summary-value"><i class="fas fa-coins"></i> {{ getGoodsTotal() }}</div>
            </div>
            <div class="summary-row">
              <div class="summary-label">当前可用积分</div>
              <div class="summary-value"><i class="fas fa-coins"></i>{{ userPoints }}</div>
            </div>
            <div class="summary-row" style="margin-top: 20px;">
              <div class="summary-label">实际需支付积分</div>
              <div class="actual-payment"><i><img src="@/assets/icon/jifen2.png" style="width: 17px;margin-bottom: 4px;" /></i> {{ total }}</div>
            </div>
          </div>

          <button class="payment-btn" @click="submitOrder">提交订单</button>
        </div>
      </div>

<!--      <div>-->
<!--        <p>收货地址</p>-->
<!--        <div v-if="!selAddress" style="text-align: center;">-->
<!--          <p style="font-weight: 550">暂无收货地址，请前往个人中心，新增收货地址！</p>-->
<!--          <a-button type="primary" @click="() => {-->
<!--            this.$router.push({-->
<!--            path: '/account',-->
<!--            query: {-->
<!--              key: 'address'-->
<!--            }-->
<!--            })-->
<!--          }">前往管理</a-button>-->
<!--          <a-divider/>-->
<!--        </div>-->
<!--        <template v-else>-->
<!--          <div class="address-active-card">-->
<!--            <div>-->
<!--              <span>{{ `${receiverStr} ${addressStr}` }}</span>-->
<!--            </div>-->
<!--            <div>-->
<!--              <a @click="visible = true, addressData = selAddress">编辑</a>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="addr-expand" :class="{expanded: addressExpanded}" @click="addressExpanded = !addressExpanded">-->
<!--            <span>更多地址</span>-->
<!--            <b></b>-->
<!--          </div>-->
<!--        </template>-->
<!--        <ul v-show="addressExpanded" class="addr-list">-->
<!--          <li v-for="addr in addressList" :key="addr.id" class="addr" @click="handleSelectAddress(addr)">-->
<!--            <div class="addr-detail">-->
<!--              {{ `${addr.name} ${addr.phoneNumber} ${addr.parentCodeName} ${addr.codeName} ${addr.detailedAddress}` }}-->
<!--            </div>-->
<!--            <span class="addr-edit">-->
<!--              <a @click.stop="visible = true, addressData = addr">编辑</a>-->
<!--            </span>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--      <div>-->
<!--        <p>商品清单</p>-->
<!--        <div v-for="item in goodsList" :key="item.companyId" style="margin-bottom: 20px">-->
<!--          <div class="cart_title">-->
<!--            <p v-for="(item, i) in goodsTitle" :key="i" :class="item.className">{{ item.title }}</p>-->
<!--          </div>-->
<!--          <div class="item-company">-->
<!--            <span>商家：</span>-->
<!--            <span>{{ item.companyName }}</span>-->
<!--          </div>-->
<!--          <div class="cart_group">-->
<!--            <div v-for="goods in item.shoppingCarts" :key="goods.id" class="goods-card">-->
<!--              <div class="goods_name title_2">-->
<!--                <div class="goods-img">-->
<!--                  <img :src="getFileUrl(goods.bridgePicUrl) || '/noimage.png'">-->
<!--                </div>-->
<!--                <p class="name">{{ goods.name }}</p>-->
<!--              </div>-->
<!--              <div class="title_3" style="text-align: center">-->
<!--                <span>{{ goods.points }}</span>-->
<!--              </div>-->
<!--              <div class="title_4" style="text-align: center">-->
<!--                <span>{{ goods.count }}</span>-->
<!--              </div>-->
<!--              <div class="title_5" style="text-align: center">-->
<!--                <span>{{ (goods.points * goods.count).toFixed(2) }}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="remark">-->
<!--            <label for="remark">采购人备注：</label>-->
<!--            <input type="text" id="remark" v-model="item.remark" />-->
<!--          </div>-->
<!--          <div class="delivery">-->
<!--            <span>积分合计：<b>{{ getGoodsTotal(item.shoppingCarts) }}</b></span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="submitOrder-footer">-->
<!--        <p>可用积分：<span>{{ userPoints }}</span></p>-->
<!--        <p>实际支付积分：<span>{{ total }}</span></p>-->
<!--        <a-button type="primary" :disabled="submitDisable" @click="submitOrder">提交订单</a-button>-->
<!--        <span v-if="!selAddress" style="color: #E44C4CFF;font-size: 16px;font-weight: 550">请选择地址</span>-->
<!--        <div v-else>-->
<!--          <span style="margin-right: 20px">寄送至：{{ `${addressStr}` }}</span>-->
<!--          <span>收件人：{{ receiverStr }}</span>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <AddressSave :visible.sync="visible" :loading.sync="loading" :addressData="addressData" @ok="handleOk"/>
  </div>
</template>
<script>
import Header from "@/components/Header";
import {createOrder, loadGoodsAvailablePoints} from "@/api/mall";
import fileUrlMixin from "@/mixins/fileUrlMixin";
import {loadAddress, loadPoints, updateAddress} from "@/api/account";
import filterCartGoodsMixin from "@/mixins/filterCartGoodsMixin";
import storage from "store";
const ORDER_RESPONSES = 'ORDER_RESPONSES'
import AddressSave from "@/views/account/modules/AddressSave";

export default {
  mixins: [fileUrlMixin, filterCartGoodsMixin],
  components: {
    Header,
    AddressSave
  },
  data () {
    return {
      goodsTitle: [
        {
          title: '商品信息',
          className: 'title_2'
        },
        {
          title: '积分',
          className: 'title_3'
        },
        {
          title: '数量',
          className: 'title_4'
        },
        {
          title: '小计',
          className: 'title_5'
        }
      ],
      goodsList: [],
      allAddressList: [],
      selAddress: null,
      addressExpanded: false,
      visible: false,
      loading: false,
      addressData: null,
      userPoints: 0
    }
  },
  computed: {
    total () {
      return Number(this.goodsList.reduce((total, g) =>
          total + g.shoppingCarts.reduce((groupTotal, p) => groupTotal + p.points * p.count, 0), 0
      ).toFixed(2))
    },
    addressList () {
      return this.allAddressList.filter(r => r.id !== this.selAddress.id)
    },
    receiverStr () {
      if (!this.selAddress) return ''
      return `${this.selAddress.name} ${this.selAddress.phoneNumber}`
    },
    addressStr () {
      if (!this.selAddress) return ''
      return `${this.selAddress.parentCodeName} ${this.selAddress.codeName} ${this.selAddress.detailedAddress}`
    },
    submitDisable () {
      return !(this.total && (this.userPoints >= this.total) && this.selAddress)
    }
  },
  mounted () {
    const x = JSON.parse(localStorage.getItem("settleAccounts"))
    this.getGoods(x)
    this.getAddress()
    this.getPoints(x)
  },
  beforeRouteLeave (to, from, next) {
    localStorage.removeItem('settleAccounts')
    next();
  },
  methods: {
    getPoints (x) {
      // loadPoints().then(res => {
      //   this.userPoints = res.data.points
      // })
      loadGoodsAvailablePoints({ supplierCompanyId: x.companyId }).then(res => {
        this.userPoints = res.data.points || 0
      })
    },
    async handleOk (data) {
      this.loading = true
      try {
        const res = await updateAddress({...data})
        if (!res.code) {
          this.visible = false
          this.getAddress()
        }
      } finally {
        this.loading = true
      }
    },
    getGoods (x) {
      // loadCart().then(res => {
        // this.goodsList = this.getCartByLabel(res.data, storage.get(selectCartId))
      // })
      this.goodsList = this.getCartByLabel2([x], [x.id])
    },
    getAddress () {
      loadAddress().then(res => {
        this.selAddress = res.data.find(r => r.ifDefaultAddress) || res.data[0]
        this.allAddressList = res.data
      })
    },
    handleSelectAddress (addr) {
      this.selAddress = addr
    },
    getPrice (item) {
      return Number((item.points * item.count).toFixed(2))
    },
    getGoodsTotal (items) {
      // return items.reduce((total, item) => total + this.getPrice(item), 0).toFixed(2)
      return this.goodsList[0]?.shoppingCarts.reduce((total, item) => total + this.getPrice(item), 0).toFixed(2)
    },
    getCartByLabel2 (cart, ids) {
      // console.log('', cart)
      const distributeCart = []
      cart.forEach(g => {
        const shoppingCarts = g.shoppingCarts
            .filter(i => ids.includes(i.id))
        if (shoppingCarts.length) {
          distributeCart.push({
            ...g,
            expand: false,
            shoppingCarts
          })
        }
      })
      return distributeCart
    },
    async submitOrder () {
      const resultList = await Promise.all((this.goodsList.map(async company => {
        // console.log('!!', company)
        const data = {
          supplierCompanyId: company.companyId,
          addressId: this.selAddress.id,
          // shoppingCartIds: company.shoppingCarts.map(goods => goods.shoppingCartId),
          items: company.shoppingCarts.map(goods => {
            return {
              goodsId: goods.id,
              count: goods.count
            }
          }),
          totalAmount: this.getGoodsTotal(company.shoppingCarts),
          remark: company.remark
        }
        try {
          const res = await createOrder({...data})
          return {
            ...res,
            supplierName: company.companyName
          }
        } catch (error) {
          return {
            ...error.response.data,
            supplierName: company.companyName
          }
        }
      })))
      storage.set(ORDER_RESPONSES, resultList)
      this.$router.push({
        path: '/complete-order'
      })
    }
  }
}
</script>
<style lang="less" scoped>

/* 主要内容容器 */
.order-container {
  max-width: 1200px;
  margin: 30px auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* 地址选择区域 */
.address-section {
  padding: 30px;
  border-bottom: 1px solid #f0f4f8;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title i {
  color: #ff9a9e;
}

.address-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e0e6ed;
}

.address-card:hover {
  border-color: #a1c4fd;
}

.address-card.active {
  border: 2px solid #84fab0;
  background: rgba(132, 250, 176, 0.1);
}

.address-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffecd2, #fcb69f);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 20px;
  flex-shrink: 0;
}

.address-info {
  flex: 1;
}

.address-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.address-name {
  font-weight: 600;
  color: #2c3e50;
}

.address-phone {
  color: #2c3e50;
}

.address-detail {
  color: #7f8c8d;
  line-height: 1.6;
}

.address-tag {
  display: inline-block;
  padding: 2px 8px;
  background: #e8f4ff;
  color: #3498db;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 10px;
}

.add-address-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border: 1px dashed #a1c4fd;
  border-radius: 12px;
  color: #2c3e50;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 15px;
}

.add-address-btn:hover {
  border-color: #84fab0;
  color: #84fab0;
}

.add-address-btn i {
  margin-right: 8px;
}

/* 商品信息区域 */
.products-section {
  padding: 30px;
  border-bottom: 1px solid #f0f4f8;
}

.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.company-logo {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(135deg, #a1c4fd, #c2e9fb);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  margin-right: 15px;
}

.company-name {
  font-weight: 600;
  color: #2c3e50;
}

.product-list {
  border: 1px solid #f0f4f8;
  border-radius: 12px;
  overflow: hidden;
}

.product-item {
  display: flex;
  padding: 20px;
  border-bottom: 1px solid #f0f4f8;
}

.product-item:last-child {
  border-bottom: none;
}

.product-image {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f5f7fa, #e4edf9);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.product-image i {
  font-size: 30px;
  color: #a1c4fd;
}

.product-info {
  flex: 1;
}

.product-name {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 5px;
}

.product-spec {
  color: #7f8c8d;
  font-size: 14px;
  margin-bottom: 10px;
}

.product-quantity {
  color: #7f8c8d;
  font-size: 14px;
}

.product-price {
  width: 150px;
  text-align: right;
}

.points-value {
  font-weight: 700;
  color: #e74c3c;
  font-size: 16px;
  margin-bottom: 5px;
}

.points-value i {
  margin-right: 5px;
  color: #ffd700;
}

.subtotal {
  color: #7f8c8d;
  font-size: 14px;
}

/* 备注区域 */
.remark-section {
  padding: 30px 0px;
  border-bottom: 1px solid #f0f4f8;
}

.remark-input {
  width: 100%;
  padding: 15px;
  border: 1px solid #e0e6ed;
  border-radius: 8px;
  font-size: 14px;
  resize: none;
  min-height: 80px;
}

.remark-input:focus {
  outline: none;
  border-color: #a1c4fd;
}

/* 支付信息区域 */
.payment-section {
  padding: 30px;
}

.payment-summary {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.summary-label {
  color: #7f8c8d;
}

.summary-value {
  color: #2c3e50;
  font-weight: 500;
}

.total-points {
  font-size: 18px;
  color: #e74c3c;
  font-weight: 700;
}

.total-points i {
  margin-right: 5px;
  color: #ffd700;
}

.actual-payment {
  font-size: 18px;
  color: #e74c3c;
  font-weight: 700;
}

.actual-payment i {
  margin-right: 5px;
  color: #ffd700;
}

.payment-btn {
  background: linear-gradient(135deg, #ff9a9e, #fad0c4);
  color: white;
  border: none;
  padding: 15px 0;
  width: 100%;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-size: 16px;
  margin-top: 20px;
}

.payment-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}

/*
  --------------------------------------
*/

#checkoutOrder {
  width: 1200px;
  margin: 0 auto;
  min-height: 95vh;
  background: linear-gradient(to bottom, #f0f8ff, #e6f7ff);;
  padding: 20px 30px;
}
#checkoutOrder > div >p {
  font-size: 16px;
  font-weight: 550;
}
.cart_title{
  display: flex;
  height: 40px;
  line-height: 40px;
  background: #F3F7FF;
  p {
    text-align: center;
    font-size: 14px;
    color: #333;
    border-right: 1px solid #fafafa;
    font-weight: 550;
    flex-shrink: 1;
  }
}
.title_2{
  width: 630px;
}
.title_3{
  width: 170px;
}
.title_4 {
  width: 170px;
}
.title_5{
  width: 170px;
}
.item-company {
  margin: 15px 0;
  span {
    font-weight: 550;
  }
}
.cart_group{
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 hsla(0, 1%, 83%, 0.5);
  overflow: hidden;
  padding: 25px 20px;
  font-weight: 550;
  .goods-card {
    padding: 10px 0;
    border-bottom: 1px dashed #e6e6e6;
    display: flex;
    align-items: center;
    .goods_name{
      display: flex;
      cursor: pointer;
      align-items: center;
      .goods-img{
        width: 80px;
        height: 80px;
        line-height: 80px;
        margin-right: 10px;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .name{
        flex: 1;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }
    }
  }
  .goods-card:last-child{
    border: none;
  }
}
.address-active-card{
  background-color: #fafafa;
  padding: 10px;
  font-size: 12px;
  font-weight: 550;
  color: #165DFF;
  display: flex;
  gap: 24px;
  justify-content: space-between;
}
.submitOrder-footer {
  background-color: #fafafa;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .ant-btn{
    margin-bottom: 20px;
  }
  p {
    span {
      font-size: 18px;
      font-weight: 550;
      color: #de0000;
    }
  }
}
.addr-expand {
  padding: 20px 10px;
  cursor: pointer;

  b {
    display: inline-block;
    width: 9px;
    height: 10px;
    line-height: 10px;
    vertical-align: middle;
    margin-left: 5px;
    background: url(../../../assets/addr-i.png) no-repeat 0 0;
  }

  &.expanded {
    b {
      background: url(../../../assets/addr-i.png) no-repeat 0 -10px
    }
  }
}
.addr-list {
  padding: 0;
  li {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    cursor: pointer;

    &.addr-active {
      color: #165DFF;
    }

    &:hover {
      background-color: #F5F6F7FF;

      .addr-edit {
        display: block;
      }
    }

    .selected {
      width: 12px;
      height: 12px;
      background-image: url(../../../assets/selected.png);
      background-size: cover;
    }

    .addr-edit {
      flex-grow: 1;
      text-align: right;
    }
  }
}
.remark {
  display: flex;
  align-items: center;
  background-color: white;
  margin: 20px 0;
  input {
    border: 1px solid #e6e6e6;
    font-size: 12px;
    outline: none;
    background-color: #fff;
    flex-grow: 1;
    height: 36px;
    padding-left: 8px;
  }
}
.delivery {
  font-size: 14px;
  font-weight: 550;
  height: 50px;
  background-color: #FFF8EAFF;
  padding-right: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  b {
    color: #E44C4CFF;
    font-size: 16px;
  }
}
</style>
